import { AppState } from 'Store'

const selectAll = (state: AppState) => state.users.user.users
const selectCurrentParams = (state: AppState) => state.users.user.requestParams
const selectEntries = (state: AppState) => state.users.user.users.entries ?? []
const selectTotal = (state: AppState) => state.users.user.users.total_entries
const selectOne = (state: AppState) => state.users.user.user
const selectPartner = (state: AppState) => state.users.user.partner
const selectOneId = (state: AppState) => state.users.user.user?.id

export const userSelector = {
	selectAll,
	selectCurrentParams,
	selectEntries,
	selectTotal,
	selectOne,
	selectPartner,
	selectOneId,
}
